// @ts-nocheck
import * as React from 'react';
// AIRecommendations — "AI Recommendations Ready" panel with dial.

import Icon from '../components/common/Icon';
import './AIRecommendations.css';

export default function AIRecommendations({ parent, topPicks }) {
  const profileFields = parent.profileFields || [];
  const availableFields = profileFields.filter(field => field.available);
  const profilePct = Math.round((availableFields.length / 5) * 100);

  const R = 46, C = 2 * Math.PI * R;
  const dash = (profilePct / 100) * C;

  return (
    <section className="A2-rec" aria-label="AI Recommendations Ready">
      <div className="A2-rec__main">
        <span className="A2-rec__eyebrow">
          <Icon name="sparkles" size={11} stroke={2} />
          Lead Profile Ready
        </span>
        <h3 className="A2-rec__title">
          For <strong>{parent.child}</strong>{parent.childAge > 0 ? `, age ${parent.childAge}` : ''}.
        </h3>
        <p className="A2-rec__sub">
          {parent.currentSchool || parent.address
            ? [parent.currentSchool, parent.address].filter(Boolean).join(' · ')
            : 'No school or address information was returned for this lead.'}
        </p>

        <div className="A2-rec__analysis">
          <span className="A2-rec__spark">
            <Icon name="sparkles" size={16} stroke={1.9} />
          </span>
          <p>{availableFields.length
            ? `${availableFields.length} verified profile fields are available for this lead.`
            : 'No profile fields were returned for analysis.'}</p>
        </div>

        {profileFields.length > 0 && <ul className="A2-rec__check">
          {profileFields.map((field) => (
            <li key={field.label} className={field.available ? '' : 'is-disabled'}>
              <Icon name="check" size={12} stroke={2.4} />
              <span>{field.label}</span>
            </li>
          ))}
        </ul>}

        <div className="A2-rec__foot">
          <p>{parent.email || parent.phone || 'No contact information returned'}</p>
        </div>
      </div>

      <div className="A2-rec__dial">
        <div className="A2-rec__dial-ring">
          <svg width="108" height="108" viewBox="0 0 108 108">
            <circle cx="54" cy="54" r={R} fill="none" stroke="rgba(22, 163, 74, 0.12)" strokeWidth="8" />
            <circle
              cx="54" cy="54" r={R}
              fill="none"
              stroke="var(--green)"
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray={`${dash} ${C - dash}`}
              transform="rotate(-90 54 54)"
            />
          </svg>
          <span className="A2-rec__dial-val">{profilePct}<sup>%</sup></span>
        </div>
        <div className="A2-rec__dial-cap">
          Profile available<br /><strong>{availableFields.length} of 5 fields</strong>
        </div>
      </div>
    </section>
  );
}
